import { render, staticRenderFns } from "./CheckboxDisableConversationPresentationShare.vue?vue&type=template&id=ab6c25e2&scoped=true&"
import script from "./CheckboxDisableConversationPresentationShare.vue?vue&type=script&lang=js&"
export * from "./CheckboxDisableConversationPresentationShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6c25e2",
  null
  
)

export default component.exports